import { teamMeta } from '../../constants';

export const UNASSIGNED_TEAM_KEY = 'unassigned';

const unassignedTeamMeta = { label: 'Other', icon: '◇' };

export const getTeamMeta = (teamKey) => teamMeta[teamKey] ?? unassignedTeamMeta;

export const groupTasksByTeam = (tasks = [], teamOrder = [], pinnedTeam = null) => {
  const tasksByTeam = new Map();

  tasks.forEach((task) => {
    const rawTeam = `${task?.team || ''}`.trim();
    const teamKey = rawTeam && teamMeta[rawTeam] ? rawTeam : UNASSIGNED_TEAM_KEY;

    if (!tasksByTeam.has(teamKey)) tasksByTeam.set(teamKey, []);
    tasksByTeam.get(teamKey).push(task);
  });

  const orderedTeamKeys = [
    ...(pinnedTeam ? [pinnedTeam] : []),
    ...teamOrder.filter((teamKey) => teamKey !== pinnedTeam),
    UNASSIGNED_TEAM_KEY,
  ];

  return orderedTeamKeys
    .filter((teamKey) => tasksByTeam.has(teamKey))
    .map((teamKey) => ({
      team: teamKey,
      ...getTeamMeta(teamKey),
      tasks: tasksByTeam.get(teamKey),
    }));
};
